import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { QuestionCheckboxComponent } from './question-checkbox.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';

@NgModule({
  imports: [
    QuestionModule,
    NgxChartsModule,
   ],
  declarations:[QuestionCheckboxComponent],
  exports:[QuestionCheckboxComponent],
})
export class QuestionCheckboxModule { }

